<template lang="pug">
.asset-slide-out
	side-sheet(
		:state='state'
		@close='close'
		@edit='$emit( "edit" )'
		@delete='$emit( "delete" )'
	)
		slot.title-container(
			slot='title'
			name='title'
			v-if='state === "opened"'
		)
		slot.side-sheet-content(
			slot='side-sheet-content'
			name='side-sheet-content'
			v-if='state === "opened"'
		)
</template>

<script>
import SideSheet from '@/components/SideSheet';
import { objectOrNull } from '@/lib/vue-validators';

import { AddRecentlyViewed } from '@/lib/db/recentlyViewed';

export default {
	name : 'asset-slide-out',

	props : {

		state : {
			type     : String,
			required : true,
		},
		asset : {
			required  : true,
			validator : objectOrNull,
		},
		assetKey : {
			required : true,
		},
		assetName : {
			type     : String,
			required : true,
		},

	},

	watch : {
		state( state ) {
			if ( state === 'opened' ) {
				return;
			}

			this.close();
		},

		asset : {
			immediate : true,
			handler( asset ) {

				// console.log( asset );

				if ( !asset ) {
					return;
				}

				if ( !Object.keys( asset ) ) {
					return;
				}

				this.addToRecentlyViewed();

			}
		}
	},

	methods : {
		close() {
			this.$emit( 'close' );

			this.$router.replace( { query : {} } );
		},

		addToRecentlyViewed() {
			const { asset, assetKey, assetName } = this;

			AddRecentlyViewed( assetName, asset, assetKey );
		},

		getValue( asset, propString ) {

			const props = propString.split( '.' );

			return props.reduce( ( value, prop ) => {

				if ( value === null || value === undefined ) {
					return null;
				}

				return value[prop];

			}, asset );

		},
	},

	components : {
		SideSheet
	}
};
</script>

<style lang="scss">

</style>
